import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import UserMaintenance from './UserMaintenance';
import UserForm from './UserForm';
import CommanLayout from 'src/Layout/CommanLayout';
import AlertUsers from './AlertUsers';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Users() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <CommanLayout name="User Maintenance" path="user-maintenance">
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Users" {...a11yProps(0)} />
                        <Tab label="Add User" {...a11yProps(1)} />
                        <Tab label="Expiring Users in 14 Days" {...a11yProps(2)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <UserMaintenance />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <UserForm />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <AlertUsers />
                </CustomTabPanel>
            </Box>
        </CommanLayout>
    );
}